// Test authentication utility
export const testAuth = {
  // Test credentials for development
  testUser: {
    email: 'test@aicarousel.com',
    password: 'testpass123',
    firstName: 'Test',
    lastName: 'User'
  },

  // Mock login for development (when backend is not available)
  mockLogin: () => {
    const mockTokens = {
      access: 'mock-access-token-' + Date.now(),
      refresh: 'mock-refresh-token-' + Date.now()
    };

    const mockUser = {
      id: 1,
      email: 'test@aicarousel.com',
      first_name: 'Test',
      last_name: 'User',
      subscription_plan: 'free'
    };

    localStorage.setItem('access_token', mockTokens.access);
    localStorage.setItem('refresh_token', mockTokens.refresh);
    localStorage.setItem('mock_user', JSON.stringify(mockUser));

    return { success: true, user: mockUser, tokens: mockTokens };
  },

  // Check if we're in development mode
  isDevelopment: () => {
    return process.env.NODE_ENV === 'development';
  },

  // Check if backend is available
  checkBackendHealth: async () => {
    try {
      const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
      const response = await fetch(`${API_BASE_URL}/health/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.ok;
    } catch (error) {
      console.warn('Backend not available:', error.message);
      return false;
    }
  }
};
